import { Head, Link, usePage } from '@inertiajs/react'
import { version as react_version } from 'react'
import { Button } from '@/components/ui/button'
import type { SharedProps } from '@/types'

export default function InertiaExample({
  rails_version,
  ruby_version,
  rack_version,
  inertia_rails_version,
}: {
  rails_version: string
  ruby_version: string
  rack_version: string
  inertia_rails_version: string
}) {
  const { user } = usePage<SharedProps>().props

  return (
    <div className="min-h-screen bg-background">
      <Head title="Vietnam Pickleball Awards 2025" />

      <header className="border-b">
        <div className="container mx-auto flex items-center justify-between px-4 py-4">
          <h1 className="font-bold text-2xl">Vietnam Pickleball Awards</h1>
        </div>
      </header>

      <main className="container mx-auto px-4 py-8">
        {/* Welcome Section */}
        <section className="mb-12 text-center">
          <h2 className="mb-4 font-bold text-4xl">
            {user
              ? `Welcome back, ${user.email.split('@')[0]}!`
              : 'Welcome to Vietnam Pickleball Awards'}
          </h2>
          <p className="mx-auto max-w-2xl text-lg text-muted-foreground">
            A modern full-stack template combining Ruby on Rails, Inertia.js, and React with
            TypeScript.
          </p>
        </section>

        {/* Quick Actions */}
        <section className="mb-12">
          <div className="flex flex-wrap justify-center gap-4">
            <Link href="/">
              <Button size="lg">Get Started</Button>
            </Link>
          </div>
        </section>

        {/* Version Info Footer */}
        <footer className="border-t pt-8 text-center text-muted-foreground text-sm">
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2">
            <span>Rails {rails_version}</span>
            <span>Rack {rack_version}</span>
            <span>Inertia Rails {inertia_rails_version}</span>
            <span>React {react_version}</span>
          </div>
          <p className="mt-2 text-xs">{ruby_version}</p>
        </footer>
      </main>
    </div>
  )
}
